import React from "react";
import AuthBrand from "components/auth/AuthBrand";

const AuthLoading = ({ message = "Processing..." }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center min-vh-100"
      style={{
        background: "linear-gradient(155deg, rgba(246,255,249,0.98) 0%, rgba(242,248,255,0.96) 100%)",
      }}
    >
      <div className="text-center" aria-live="polite" aria-busy="true">
        <AuthBrand centered size={96} />
        <p
          className="mt-3 mb-0 fw-semibold"
          style={{ color: "#2385DB", fontSize: 16 }}
        >
          {message}
        </p>
      </div>
    </div>
  );
};

export default AuthLoading;
